<template lang="html">

  <div id="ajusa" class="ajusa--view ajusa">

    <intro></intro>

    <section>
      <ul class="menu-nosotros flex row">
        <li class="flex column justify-center pink" v-scroll-to="'#aj-calidad'"><a href="#">{{$t('ajusa.enlaces.calidad')}}</a></li>
        <li class="flex column justify-center yellow" v-scroll-to="'#aj-servicios'"><a href="#">{{$t('ajusa.enlaces.servicio')}}</a></li>
        <li class="flex column justify-center pink" v-scroll-to="'#aj-compromiso'"><a href="#">{{$t('ajusa.enlaces.compromiso')}}</a></li>
        <li class="flex column justify-center yellow" v-scroll-to="'#aj-equipo'"><a href="#">{{$t('ajusa.enlaces.equipo')}}</a></li>
        <li class="flex column justify-center pink" v-scroll-to="'#aj-catalogo'"><a href="#">{{$t('ajusa.enlaces.catalogo')}}</a></li>
      </ul>
    </section>


    <section id="aj-calidad" class="sec-ajusa">
      <div class="flex wrap">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/ajusa/aj-calidad.webp">
          <img class="img-aj col-75  waypoints" data="fadeInUp" src="/static/img/ajusa/aj-calidad.webp" :alt="$t('ajusa.alt_images.fabricante_tubos_engrase')" width="1587" height="1059" loading="lazy">
        </picture> 
        <article class="container-text col-25 waypoints" data="fadeInRight">
          <h2 class="title title-72">{{$t('ajusa.calidad.titulo')}}</h2>
          <p>{{$t('ajusa.calidad.texto')}}</p>
        </article>
      </div>
    </section>

    <section id="aj-servicios" class="sec-ajusa">
      <div class="flex row-reverse wrap">
        <img class="img-aj col-75  waypoints" data="fadeInUp" src="/static/img/ajusa/aj-servicio.webp" :alt="$t('ajusa.alt_images.factoria_automocion')" width="923" height="655" loading="lazy"> 
        <article class="container-text col-25 waypoints" data="fadeInLeft">
          <h2 class="title title-72 ">{{$t('ajusa.servicio.titulo')}}</h2>
          <p>{{$t('ajusa.servicio.texto')}}</p>
        </article>
      </div>
    </section>

    <section id="aj-compromiso" class="sec-ajusa">
      <div class="flex wrap">
        <img class="img-aj col-60  waypoints" data="fadeInUp" src="/static/img/ajusa/aj-compromiso.webp" :alt="$t('ajusa.alt_images.social')" width="972" height="648" loading="lazy"> 
        <article class="container-text col-40 waypoints" data="fadeInRight">
          <h2 class="title title-72" v-html="$t('ajusa.compromiso.titulo')"></h2>
          <p>{{$t('ajusa.compromiso.texto')}}</p>
          <a class="btn btn-light  -pink mt-20" :href="$t('ajusa.compromiso.pdf')" target="_blank">{{$t('ajusa.compromiso.texto_btn')}}</a>
        </article>
      </div>
    </section>

    <section id="aj-equipo" class="sec-ajusa">
      <div class="flex row-reverse wrap">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/ajusa/aj-equipo.webp">
          <img class="img-aj col-60  waypoints" data="fadeInUp" src="/static/img/ajusa/aj-equipo.webp" :alt="$t('ajusa.alt_images.factoria_automocion')" width="1920" height="1282" loading="lazy">
        </picture> 
        <article class="container-text col-40 waypoints" data="fadeInLeft">
          <h2 class="title title-72">{{$t('ajusa.equipo.titulo')}}</h2>
          <p>{{$t('ajusa.equipo.texto')}}</p>
        </article>
      </div>
    </section>

    <section id="aj-catalogo" class="sec-ajusa" :lang="getRealLanguage">
      <div class="flex wrap">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/ajusa/aj-catalogo.webp">
          <img class="img-aj col-75 waypoints" data="fadeInUp" src="/static/img/ajusa/aj-catalogo.webp" :alt="$t('ajusa.alt_images.catalog_juntas')" width="1920" height="1280" loading="lazy">
        </picture> 
        <article class="col-25">
          <div class="flex wrap pad-sec text-ajusa waypoints" data="fadeInUp">
            <article class="col-100 flex row justify-end waypoints" data="fadeInLeft">
              <h2 class="title title-72">{{$t('ajusa.catalogo.titulo')}}</h2>
            </article>
            <article class="container-text col-100 flex row justify-start waypoints" data="fadeInRight">
              <p>{{$t('ajusa.catalogo.texto')}}</p>
            </article>
          </div>    
        </article>
      </div>
      
    </section>

    <section class="sec-center pad-sec">
      <div class="container waypoints" data="fadeInUp">
        <h2 class="title title-36">{{$t('ajusa.excelencia.titulo')}}</h2>
        <p>{{$t('ajusa.excelencia.texto')}}<strong class="bold"><a target="_blank" v-html="$t('ajusa.excelencia.enlace_texto')"></a></strong><span  v-html="$t('ajusa.excelencia.texto_2')"></span></p>
         <a class="btn btn-dark -yellow-full" target="_blank" :href="$t('enlaces.productos_certificados')">{{$t('ajusa.excelencia.boton')}}</a>
      </div>
    </section>


    <section id="history" class="block-historia sec-foto blue">
      <picture>
        <source media="(max-width: 900px)" srcset="/static/img/responsive/bkg/bkg-historia.webp">
        <img class="w-100" src="/static/img/bkg/bkg-historia.webp" :alt="$t('ajusa.alt_images.historia')" width="1355" height="680" loading="lazy">
      </picture>
      <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
        <div class="col-50 text-container">
          <router-link :to="$t('enlaces.aniversario50')"></router-link>
          <h3 class="title title-52">{{$t('ajusa.historia.titulo')}}</h3>
          <p>{{$t('ajusa.historia.texto')}}</p>
          <p class="go">{{$t('ajusa.historia.boton')}}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></p>
        </div>
      </div>
    </section>


    <banner-ajusa-th></banner-ajusa-th>
    
    <otras-secciones :data="['actualidad','area_tecnica']"></otras-secciones>


  </div>

</template>

<script lang="js">

  import Intro from '@/components/view-parts/intros/ajusa'
  
  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

    import bannerAjusaTh from '@/components/parts/banner-ajusa-th';
     import {mapGetters} from 'vuex';


  export default  {
    name: 'ajusa',
    props: [],
    mounted() {
      $(window).scroll(function(event) {

        var distancia = $(window).scrollTop();
        var altura = $(window).height();

        if(distancia >= 575){
          $(".menu-nosotros").addClass('fixed');
          $(".menu-catalogo-h").addClass('show');
          $(".solicitar-cat").addClass('show');
        }else{
          $(".menu-nosotros").removeClass('fixed');
          $(".menu-catalogo-h").removeClass('show');
          $(".solicitar-cat").removeClass('show');
        }
      });
      $('.menu-nosotros li').click(function(){ 
        $('.menu-nosotros li').removeClass('active')
        $(this).addClass('active')  
      })

    // El intercambio por la version reducida lo hace ahora el atributo `srcset`
    // de cada <img>. Antes se sustituia aqui el `src`, ya renderizada la pagina,
    // cuando el navegador ya habia empezado a descargar la version grande.
    },
    data() {
      return {

      }
    },
    methods: {
     
    },
    computed: {
      ...mapGetters(['getServer', 'getLanguage', 'getRealLanguage']),
    },
    components: {
      'otras-secciones' : Otras_Secciones,
      'intro' : Intro,
      'banner-ajusa-th' : bannerAjusaTh

    }
  }
</script>

<style scoped>
.btn-dark {
  margin-top: 20px;
}
#aj-servicios .title,
#aj-equipo .title,
.menu-nosotros li.active.yellow{
  color: #ffed00;
}
#aj-calidad .title,
#aj-compromiso .title,
#aj-catalogo .title,
.menu-nosotros li.active.pink{
  color:#E6007E;
}

</style>



// WEBPACK FOOTER //
// src/components/views/ajusa.vue